<div class="mt-4 mb-3">
  <div *ngIf="hasRates()">
    <p *ngFor="let data of results">
      <a *ngIf="data.assetTypeId == 4 || data.assetTypeId == 6" class="tittle1 font-weight-bold" rel="noopener noreferrer" (click)="onMedialinkClick(data.url)" style="display:block"> {{data.assetName}}.pdf</a>
    </p>
  </div>
  <div class="tittle1 font-weight-bold" *ngIf="!hasRates()"> No Rates</div>
</div>